const GTAG_LOADER_URL = 'https://www.googletagmanager.com/gtag/js';

function hasLoader(scripts) {
  return scripts.some((entry) => entry && typeof entry.script === 'string' && entry.script.indexOf(GTAG_LOADER_URL) > -1);
}

function hasConfig(scripts, tagId) {
  return scripts.some((entry) => entry && typeof entry.script === 'string' && entry.script.indexOf(`gtag('config', '${tagId}')`) > -1);
}

/**
 * [FW-4033] Library gtag hanya dimuat sekali per halaman. Sebelumnya setiap conversion ID
 * (dan GTA lama yang sudah dimigrasi ke pixelsGoogleAds) menyuntikkan loader-nya sendiri,
 * sehingga gtag.js terunduh dua kali. `gtag('config', ...)` tetap dikirim per ID supaya
 * konversi Google Ads untuk semua ID yang dipasang seller tetap tercatat.
 *
 * @param {Array} scripts - Daftar script yang dirender VueScriptComponent (jadi sumber kebenaran per halaman).
 * @param {string} tagId - Tag ID lengkap, mis. "AW-123456789".
 */
export function pushGtagScripts(scripts, tagId) {
  if (!hasLoader(scripts)) {
    scripts.push({
      script: `<script defer src='${GTAG_LOADER_URL}?id=${tagId}'></script>`,
      name: "GTA",
      type: "GTA"
    });
  }

  if (hasConfig(scripts, tagId)) return;

  scripts.push({
    script: `<script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', '${tagId}');</script>`,
    name: "GTA",
    type: "GTA"
  });
}
